import { useTranslation } from "@i18n";
import { useEffect, useState, useRef } from "react";
import { getFlatTreeViewOfDistinctFileProperties } from "@Services/utils/helpers";
import TreeSelectDropDown from "@CubeComponents/html/TreeDropDown";
type props = {
  columns: any;
  change: Function;
  value?: string | null;
  placeholder?: string;
};

function FileColumnsTreeView({ columns, change, value, placeholder }: props) {
  const { t } = useTranslation();
  const [columnData, setColumnData] = useState<any>([]);
  const treeRef = useRef<any>(null);

  useEffect(() => {
    // Use flat data with parentId references
    setColumnData(
      getFlatTreeViewOfDistinctFileProperties(
        columns,
        undefined,
        undefined,
        { selectable: true },
        { selectable: false },
      ),
    );
  }, [columns]);

  return (
    <div className="w-full">
      <TreeSelectDropDown
        value={value}
        ref={treeRef}
        treeData={columnData}
        placeholder={placeholder || t("Select Quantity Parameter")}
        enableCheckboxSelection={false}
        multiple={false}
        onSelectionChange={change}
        popoverWidth={300}
        selectCheckBoxOnRowClick
        popoverHeight={400}
        disabledParentSelection
      />
    </div>
  );
}

export default FileColumnsTreeView;
